/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCaseAlert } from './InternalApiCaseAlert';
import {
    InternalApiCaseAlertFromJSON,
    InternalApiCaseAlertFromJSONTyped,
    InternalApiCaseAlertToJSON,
    InternalApiCaseAlertToJSONTyped,
} from './InternalApiCaseAlert';

/**
 * 
 * @export
 * @interface InternalApiCaseAlertPage
 */
export interface InternalApiCaseAlertPage {
    /**
     * 
     * @type {number}
     * @memberof InternalApiCaseAlertPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiCaseAlertPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiCaseAlertPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiCaseAlert>}
     * @memberof InternalApiCaseAlertPage
     */
    content: Array<InternalApiCaseAlert>;
}

/**
 * Check if a given object implements the InternalApiCaseAlertPage interface.
 */
export function instanceOfInternalApiCaseAlertPage(value: object): value is InternalApiCaseAlertPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiCaseAlertPageFromJSON(json: any): InternalApiCaseAlertPage {
    return InternalApiCaseAlertPageFromJSONTyped(json, false);
}

export function InternalApiCaseAlertPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCaseAlertPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiCaseAlertFromJSON)),
    };
}

export function InternalApiCaseAlertPageToJSON(json: any): InternalApiCaseAlertPage {
    return InternalApiCaseAlertPageToJSONTyped(json, false);
}

export function InternalApiCaseAlertPageToJSONTyped(value?: InternalApiCaseAlertPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiCaseAlertToJSON)),
    };
}

